<app-content-container
  [isLoading]="(patientInsuranceCardsState$ | async)?.isLoading"
  [error]="(patientInsuranceCardsState$ | async)?.error"
>
  <div class="flex align-items-center justify-content-between flex-wrap">
    <h2 class="my-1">Insurance</h2>
    <button
      pButton
      type="button"
      label="Add New Insurance"
      icon="mi-round mi-add-circle-outline"
      class="p-button-text p-button-sm mt-2 sm:mt-0"
      (click)="showModal()"
      data-cy="add-new-insurance-button"
      appClickEvent
      eventName="profile_add_insurance"
    ></button>
  </div>
  <p-divider></p-divider>
  <div>
    <div
      *ngIf="!((patientInsuranceCardsState$ | async)?.data || []).length"
      class="mt-8 flex flex-column align-items-center"
      data-cy="no-insurance"
    >
      <img src="./assets/icons/divisional-icons/clipboard-blue.svg" height="80px" alt="Clipboard Icon" />
      <h3>No Insurance Found</h3>
    </div>
    <div *ngFor="let insuranceCard of (patientInsuranceCardsState$ | async)?.data; let i = index">
      <p-divider *ngIf="i > 0"></p-divider>
      <div class="flex adjust-content-start align-items-center my-5" data-cy="profile-insurance-card">
        <h3 class="my-0">{{ insuranceCard.typeDesc | titlecase }} Insurance</h3>
        <p-tag
          *ngIf="insuranceCard.status"
          styleClass="p-tag-sm ml-2"
          [value]="insuranceCard.status"
          [severity]="getInsuranceStatusSeverity(insuranceCard.status)"
          data-cy="profile-insurance-card-status"
        ></p-tag>
      </div>

      <app-insurance-details [insurance]="insuranceCard"></app-insurance-details>
    </div>
  </div>
</app-content-container>

<app-insurance-form
  title="Add New Insurance"
  [(visible)]="displayModal"
  [includeInsuranceType]="true"
  successMessageServiceKey="profileMessages"
>
</app-insurance-form>
